import styled from 'styled-components';
import image from '../../images/nda/home-offer-2.webp';

const S = {}

S.TrackingWrapper = styled.div`
    max-width: 1200px;
    margin: 60px auto;
    display: flex;

    & .right-column, &.left-column {
        margin: 0 30px;
    }

    @media(max-width: 768px) {
        margin: 60px 15px;
        flex-direction: column;
        height: initial;

        & h2 {
            text-align: left;
        }
    }

    & .left-column {
        flex: 1;
        flex-direction: column;
    }
    & .right-column {
        flex: 1;
    }
`;

S.TrackingTitle = styled.h2`
    color: #343434;
    font-weight: 700;
    margin-bottom: 10px;
`;

S.TrackingDescription = styled.p`
    margin: 60px 0;
    font-size: 22px;
    letter-spacing: 0px;
    font-weight: 100;

    & ul {
        list-style-type: none;
        & li {
            position: relative;
            margin-bottom: 15px;
            font-size: 18px;
            & ::before {
                content: '';
                position: absolute;
                top: 5px;
                width: 0;
                height: 0;
                border-top: 5px solid transparent;
                border-left: 10px solid #22283B;
                border-bottom: 5px solid transparent;
                margin-right: 5px;
                left: -30px;
            }
        }
    }
`;

S.TrackingMap = styled.div`
    background-image: url(${image});
    background-position: center;
    background-size: cover;
    height: 100%;
    background-repeat: no-repeat;
    border-radius: 5px 35px;

    @media (max-width: 768px) {
        min-height: 500px;
        background-size: auto;
    }
`;


export default S;